import { View } from 'backbone';

import BreadCrumbView from 'BreadCrumbView.js';
import _template from 'designer/layout-behavior-toolbox-pane.ejs';


class ToolboxPaneView extends View {



    initialize( opts ) {
        this.options = opts || {};
        this.template = _template;
        this.tagName = 'div';
        this.id = opts.el;


        return this;
    }



    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.breadCrumbView = new BreadCrumbView({
            el: this.$el.find('.pf-breadcrumb') 
        }).render();
        
        this.delegateEvents();
        return this;
    }

}

export default ToolboxPaneView;
